import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TelegramIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M28.4554 4.22082C24.4976 5.87352 7.52811 12.9617 2.8393 14.8936C-0.305316 16.1311 1.53541 17.2912 1.53541 17.2912C1.53541 17.2912 4.21961 18.2191 6.52043 18.9152C8.82126 19.6113 10.0484 18.8378 10.0484 18.8378L20.8622 11.4905C24.6969 8.86112 23.7767 11.0265 22.8564 11.9544C20.8622 13.9654 17.5645 17.1361 14.8035 19.6884C13.5764 20.7711 14.19 21.6993 14.7268 22.1633C16.721 23.8647 22.1661 27.3449 22.4731 27.5771C24.0934 28.7336 27.2803 30.3988 27.765 26.881L29.6825 14.7389C30.2961 10.6399 30.9097 6.85018 30.9864 5.76748C31.2163 3.13813 28.4554 4.22082 28.4554 4.22082Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
